import * as React from 'react';
import styled from 'styled-components';
import { IIconProps } from './models';
import * as styles from './styles';

export const Icon = styled(({ className, size, src, onClick, dataAt }: IIconProps) => {
  return <img className={className} src={src} data-at={dataAt} onClick={onClick} />;
})`
  ${styles.Icon}
`;

Icon.defaultProps = {
  size: 'small',
};
